// extracted by mini-css-extract-plugin
export default {"title":"PortletTitle__title--96T"};